(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const links = [...root.querySelectorAll('.anchor-nav a')];
    const header = document.querySelector('.shopify-section--header');
    let pending = false;
    function update() {
      if (!root.isConnected) return;
      const r = header?.getBoundingClientRect();
      const offset = r && r.bottom > 0 ? r.bottom : 0;
      root.style.setProperty('--xcf-header-offset', `${Math.round(offset)}px`);
      let current = links[0];
      for (const a of links) {
        if (root.querySelector(a.hash)?.getBoundingClientRect().top <= offset + 185) current = a;
      }
      for (const a of links) {
        a.classList.toggle('active', a === current);
        if (a === current) a.setAttribute('aria-current', 'location');
        else a.removeAttribute('aria-current');
      }
    }
    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { update(); pending = false; });
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    for (const a of root.querySelectorAll('a[href^="#xcf-"]')) {
      a.addEventListener('click', e => {
        const target = root.querySelector(a.hash);
        if (!target) return;
        e.preventDefault();
        update();
        const headerRect = header?.getBoundingClientRect();
        const offset = headerRect ? Math.max(headerRect.bottom, headerRect.height, 0) : 0;
        window.scrollTo({top:window.scrollY + target.getBoundingClientRect().top - offset - 110, behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
        history.replaceState(null, '', a.hash);
      });
    }
    const cleanup = event => {
      if (!event.target.contains(root)) return;
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      document.removeEventListener('shopify:section:unload', cleanup);
    };
    document.addEventListener('shopify:section:unload', cleanup);
    update();
  }
  document.querySelectorAll('.xcf').forEach(init);
  if (!window.xtraCategoryEditorBound) {
    document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.xcf').forEach(init));
    window.xtraCategoryEditorBound = true;
  }
})();
